import React, { useEffect } from 'react';
import useContext from '../../../../../hooks/useContext';
import { ILeadtimeOption, defaultLeadtimeOption } from '../../Providers/useFilters';
import InputCheckbox from '../../../../../styled/InputCheckbox';
import LinkButton from '../../../../../styled/LinkButton';

import { StoreContext } from '../../../../../providers/store';
import useDropdownMenu from '../../../../../components-legacy/DropdownMenu/useDropdownMenu';
import DropdownMenu from '../../../../../components-legacy/DropdownMenu';
import { ChevronDownIcon, ChevronUpIcon } from '../../../../../styled/Icon';
import Box from '../../../../../styled/Box';

interface ILeadtimeFilterOptions {
  leadtimeFilterOptions: ILeadtimeOption[];
  setSelectedLeadtimeOption: React.Dispatch<
    React.SetStateAction<{ property: string; value: FilterValue; label: string }>
  >;
  selectedLeadtimeOption: { property: string; value: FilterValue; label: string };
  updateLeadtimeFilters: (property: string, value?: FilterValue) => void;
  pendingStoreChange: boolean;
  togglePendingStoreChange: () => void;
  checked: boolean;
}

export default function LeadtimeFilterOptions({
  leadtimeFilterOptions,
  setSelectedLeadtimeOption,
  selectedLeadtimeOption,
  updateLeadtimeFilters,
  pendingStoreChange,
  togglePendingStoreChange,
  checked,
}: ILeadtimeFilterOptions) {
  const { showMenu, toggleShowMenu, bodyRef } = useDropdownMenu();
  const { loading, userStore, showUserStorePanel } = useContext(StoreContext);

  const disableTrigger = !userStore || !checked;
  const isDefaultLeadtimeOption = selectedLeadtimeOption.label === defaultLeadtimeOption.label;

  const onChange = (item: ILeadtimeOption) => {
    setSelectedLeadtimeOption(item);
    updateLeadtimeFilters(item.property, item.value);
    toggleShowMenu();
  };

  useEffect(() => {
    // Navigating to a ling with deliveryQuery already populated. Make sure to set state for filters.leadtime
    // if userStore in storeContext is set, if not prompt user to select a store.
    //
    // OR
    //
    // If UserStore is changed somewhere else in the application or maybe deleted through localstorage. We make
    // make sure to either prompt store selection or update filters.leadtime. This will also make store searchparameter
    // to update via listener in useFilter hook.
    if (!loading && userStore && checked) {
      updateLeadtimeFilters(selectedLeadtimeOption.property, selectedLeadtimeOption.value);
    }
    if (!loading && !userStore && checked) {
      updateLeadtimeFilters(selectedLeadtimeOption.property, undefined);
    }
    // Enables to set state onClose in userStorePanel. That way you dont have to first select a store
    // and then check the checkbox. Unable to pass a setter to userStorePanel component :/
    if (!loading && !showUserStorePanel && pendingStoreChange) {
      updateLeadtimeFilters(
        selectedLeadtimeOption.property,
        !userStore ? undefined : selectedLeadtimeOption.value,
      );
      togglePendingStoreChange();
    }
  }, [userStore, loading, checked]);

  return (
    <div ref={bodyRef}>
      <div>
        <LinkButton className="full" disabled={disableTrigger} onClick={toggleShowMenu}>
          <span className="flex-grow">
            {isDefaultLeadtimeOption ? 'Välj leveranstid' : selectedLeadtimeOption.label}
          </span>
          {!showMenu && <ChevronDownIcon className="xlarge bump-left" strokeWidth="2" />}
          {showMenu && <ChevronUpIcon className="xlarge bump-left" strokeWidth="2" />}
        </LinkButton>
      </div>
      {showMenu && (
        <DropdownMenu onClose={toggleShowMenu}>
          <Box className="no-spacing" padding="y">
            {leadtimeFilterOptions &&
              leadtimeFilterOptions.map((item) => (
                <Box key={(item as any).name + item.property} className="no-spacing" padding="2">
                  <InputCheckbox
                    id={item.label}
                    checked={selectedLeadtimeOption.property === item.property}
                    onChange={() => onChange(item)}
                    type="radio">
                    {item.label}
                  </InputCheckbox>
                </Box>
              ))}
          </Box>
        </DropdownMenu>
      )}
    </div>
  );
}
